
















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";
import AppConsts from "@/lib/appconst";
import Customer from "../../../store/entities/customers/customer";

class PageReturnOrderRequest extends PageRequest {
  customerId: number;
  clientCode: string;
  statusCode: string;
  fromDate: Date;
  toDate: Date;
}

@Component
export default class ReturnOrder extends mixins(ListMixin, AbpBase) {
  namespace = "returnOrder";
  clients = [];
  statuses = [];
  pagerequest: PageReturnOrderRequest = new PageReturnOrderRequest();
  creationTime: Date[] = [];
  customer: Customer = new Customer();
  customers: Array<Customer> = new Array<Customer>();
  customerLoading: boolean = false;
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.$store
      .dispatch({
        type: "customer/searchCustomerForSelect",
        data: {
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.customers = result;
        this.customerLoading = false;
      });
  }
  async getStatuses() {
    this.$store
      .dispatch({
        type: `${this.namespace}/getStatusForSelect`,
        data: {
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.$set(this.pagerequest, "statusCode", re[0].code);
        this.statuses = re;
      });
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: {
          hasAllItem: true,
        },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        this.pagerequest.clientCode =
          this.clients.length > 0 ? this.clients[0].code : "";
      });
  }
  //=============
  get store() {
    return this.$store.state.returnOrder;
  }

  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;

    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }

  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("Client"),
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.client)) return "";
        return h("span", `${params.row.client.displayName} `);
      },
    },
    {
      title: Util.L("ReturnOrderCode"),
      width: 140,
      key: "code",
    },
    {
      title: Util.L("Status"),
      width: 100,
      key: "statusText",
    },
    {
      title: Util.L("Customer"),
      render: (h: any, params: any) => {
        if (_.isNil(params.row.customer)) return "";
        return h(
          "span",
          `${params.row.customer.code} - ${params.row.customer.name}`
        );
      },
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      width: 170,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: Util.L("Action"),
      width: 70,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  async created() {
    await this.getClients();
    await this.getStatuses();
    var defaultDate = new Date();
    var defaultDateFrom = moment()
      .add(-7, "d")
      .toDate();
    this.creationTime = [defaultDateFrom, defaultDate];
  }
}
